.status-pill {
  align-items: center;
  border-radius: 1.5rem;
  display: flex;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  width: fit-content;
}

.status-pill__possible {
  background-color: var(--color-forest-100);
  color: var(--color-forest-900);
}

.status-pill__impossible {
  background-color: var(--color-red-100);
  color: var(--color-red-800);
}

.status-pill__new {
  background-color: var(--color-navy-100);
  color: var(--color-navy-600);
  font-size: var(--font-size-text-non-essential);
}

.status-pill__dark {
  background-color: var(--color-uva-black);
  color: var(--color-uva-white);
  font-size: var(--font-size-text-non-essential);
  font-weight: var(--semibold);
}

.status-pill--bar {
  border-radius: 0;
  justify-content: center;
  padding: 0.5rem;
  width: 100%;
}

.status-pill--compact {
  height: 1.125rem;
  padding: 0.125rem 0.5rem 0 0.5rem;
}
